/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react'
import Filter from '../../assets/images/filter.svg'

interface MovementsListProps {
  children: JSX.Element | JSX.Element[]
  title: string
  filterClick: () => void
  isError?: boolean
}

const MovementsList = ({
  children,
  title,
  filterClick,
  isError = false
}: MovementsListProps) => (
  <>
    <div className='flex bg-color-black items-center py-4 px-5 justify-between rounded-[10px]'>
      <span className='font-bold text-xs text-white'>{title}</span>
      {!isError && (
        <button type='button' onClick={filterClick} className='block'>
          <img src={Filter} alt='Filtrar' />
        </button>
      )}
    </div>
    <div
      className={`flex py-3 flex-col overflow-x-hidden space-y-[10px] max-h-72 overflow-y-auto ${
        !!isError && 'bg-inherit'
      }`}
    >
      {children}
    </div>
  </>
)

export default MovementsList
